module.exports = __webpack_public_path__ + "media/images/flags/64/Wales-0a59df92d486666f93c33d77f3ef43a0.png";